import { render, staticRenderFns } from "./dagena.vue?vue&type=template&id=262c7210&scoped=true&"
import script from "./dagena.vue?vue&type=script&lang=js&"
export * from "./dagena.vue?vue&type=script&lang=js&"
import style0 from "./dagena.vue?vue&type=style&index=0&id=262c7210&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262c7210",
  null
  
)

export default component.exports